import API from 'services/api.js';
import { URL_GET_CLIENT_IDS, URL_CLIENT_USERS } from 'services/urls.js';

export function actionFetchUserList(client_id) {
	return API.get(URL_CLIENT_USERS, {
		params: { clientId: client_id },
	})
		.then((resp) => {
			return resp.data;
		})
		.catch(() => {
			return [];
		});
}

export function actionAddUser(client_id, details) {
	return API.post(URL_CLIENT_USERS, details, {
		params: { clientId: client_id },
	}).then((resp) => {
		if (resp.status === 200) return true;
	});
}

export function actionUpdateUserRole(client_id, email, role) {
	const body = { email, role };
	return API.post(URL_CLIENT_USERS, body, {
		params: { clientId: client_id },
	}).then((resp) => {
		if (resp.status === 200) return true;
	});
}

export function actionRemoveUser(client_id, email) {
	return API.delete(URL_CLIENT_USERS, {
		params: { clientId: client_id },
		data: { email },
	}).then((resp) => {
		console.log(`delete user response ${resp.status} ${resp.data}`);
		if (resp.status === 200) {
			return true;
		}
	});
}

export function actionFetchAccountDetails(client_id) {
	return API.get(URL_GET_CLIENT_IDS, {
		params: { clientId: client_id },
	}).then((resp) => {
		return resp.data;
	});
}
export function actionFetchZohoAccount(zoho_crm_id) {
	return API.get(URL_GET_CLIENT_IDS, {
		params: { zohoCrmId: zoho_crm_id },
	}).then((resp) => {
		return resp.data;
	});
}
export function actionSyncAccountFromZoho(zoho_crm_id) {
	return API.post(URL_GET_CLIENT_IDS, { zohoCrmId: zoho_crm_id }).then(
		(resp) => {
			console.log(`update account name response ${resp.status}`);
			return resp.status === 200;
		}
	);
}
